import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { LocalizedRouteService, ProfileState } from '@lexplus-shared-lib';
import { AUTH_ROUTE_IDS, LOCALIZED_AUTH_ROUTES } from '@lexplus-authentication';

/**
 * Lets only signed-in users with the `ADMIN` role through, and redirects to the login
 * otherwise. Complements `IsLoggedInGuard` (order: login check first, then the admin
 * role) and acts as the frontend-side safeguard on top of the server-side
 * enforcement (admin-only login + admin API guard).
 */
export const AdminOnlyGuard: CanActivateFn = (): boolean => {
  const store = inject(Store);
  const router = inject(Router);
  const localizedRouteService = inject(LocalizedRouteService);

  if (store.selectSnapshot(ProfileState.isAdmin)) {
    return true;
  }

  const loginRoute =
    '/' + localizedRouteService.getLocalizedRoute(LOCALIZED_AUTH_ROUTES[AUTH_ROUTE_IDS.ROOT], LOCALIZED_AUTH_ROUTES[AUTH_ROUTE_IDS.LOGIN]);
  void router.navigateByUrl(loginRoute);
  return false;
};
